<template>
  <div class="d-flex justify-center align-center flex-column">
    <div style="width: 100%; max-width: 600px;" class="pa-3">
      <p>Olá, <strong>{{user.name}}</strong>! Vamos falar de privacidade e dados pessoais?</p>
      <p>Quem nos acompanha há um tempo sabe que segurança é um tema muito importante para nós. Portanto, estamos comprometidos com a sua privacidade, a integridade dos seus dados pessoais e com o seu direito como titular dos mesmos. Para saber mais detalhes sobre o tratamento dos dados, leia nossos Termos de uso e política de privacidade. Ao usar o Gerenciador de links, você nos fornece dados. Porém, todos eles pertencem a você, e de acordo com a Lei Geral de Proteção de Dados Pessoais - Lei N° 13.709/2018 - (LGPD), você pode exportá-los e também pedir a exclusão da sua conta.</p>
      <p>Se você optar por "Exportar meus dados", todas as informações que estão na sua conta da Zaper serão baixadas em formato csv e serão enviadas a você através do e-mail cadastrado na Zaper, <span class="font-weight-bold">{{user.email}}</span>, em até 30 dias úteis.</p>
      <v-btn dark depressed color="teal accent-4" @click="lgpd()" style="width: 250px;" :loading="loadingExportMyData">exportar meus dados</v-btn>
      <p class="mt-4">Mas se você optar por "Excluir minha conta", seus dados serão excluídos definitivamente. Você estará deletando a sua conta com todos os seus links, domínios, projetos e dados. Mas preste atenção: esta ação é irreversível! Um e-mail de confirmação da exclusão será enviado para <span class="font-weight-bold">{{user.email}}</span> com as instruções para realizar a exclusão.</p>
      <v-dialog
        v-model="dialogDestroy"
        max-width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" dark depressed color="red darken-2" style="width: 250px;">excluir minha conta</v-btn>
        </template>
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            Tem certeza que deseja excluir sua conta?
            <v-btn icon @click="dialogDestroy = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <div class="pl-6 pr-6 pt-6">
            Enviaremos uma mensagem de confirmação em seu email. Para isso precisamos que você escreva no campo abaixo <strong>”Tenho certeza"</strong> e em seguida clique em remover.
          </div>
          <div class="d-flex align-center pa-6">
            <v-text-field
              outlined
              hide-details
              placeholder="TENHO CERTEZA"
              v-model="textDestroy"
              dense
            ></v-text-field>
            <v-btn
              depressed
              color="red darken-2"
              :dark="!disabledDestroy"
              :loading="loadingDestroyAccount"
              style="width: 150px;"
              class="ml-3"
              :disabled="disabledDestroy"
              @click="destroyAccount()"
            >Excluir conta</v-btn>
          </div>
        </v-card>
      </v-dialog>
      <div class="mt-10 mb-1 font-weight-bold">Ficou com alguma dúvida?</div>
      <v-dialog
        v-model="dialogMessage"
        max-width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" dark depressed color="light-blue" style="width: 250px;">enviar mensagem</v-btn>
        </template>
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            Escreva sua dúvida!
            <v-btn icon @click="dialogMessage = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <div class="pl-6 pr-6 pt-6">
            <v-textarea
              outlined
              hide-details
              label="Descreva sua dúvida"
              v-model="textMessage"
              dense
            ></v-textarea>
          </div>
          <div class="d-flex justify-end pa-6">
            <v-btn
              depressed
              color="green darken-2"
              dark
              style="width: 150px;"
              :loading="loadingMessage"
              @click="support()" 
            >Enviar</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      loading: false,
      dialogDestroy: false,
      textDestroy: '',
      dialogMessage: false,
      textMessage: '',
      loadingDestroyAccount: false,
      loadingMessage: false,
      loadingExportMyData: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    disabledDestroy () {
      return !/^tenho certeza$/i.test(this.textDestroy)
    }
  },
  methods: {
    async destroyAccount () {
      this.loadingDestroyAccount = true
      try {
        await this.$store.dispatch('auth/removeAccount')
        this.textDestroy = ''
        this.dialogDestroy = false
        alert('Um email com instruções foi enviado para você. Deverá chegar em alguns instantes.')
      } catch (e) {
        alert('Oops! Infelizmente ocorreu um erro ao prosseguir com a exclusão. Na dúvida, contate o suporte.')
      }
      this.loadingDestroyAccount = false
    },
    async lgpd () {
      if (!window.confirm(`Tem certeza que deseja receber um relatório dos seus dados no seu email cadastrado: ${this.user.email}?`)) {
        return false
      }

      this.loadingExportMyData = true
      try {
        await this.$store.dispatch('auth/exportMyData')
        alert('Processamos sua solicitação e em até 30 dias úteis seu relatório de dados será enviado no seu email cadastrado. Obrigado.')
      } catch (e) {
        alert('Oops! Infelizmente ocorreu um erro ao executar a operação. Na dúvida, contate o suporte.')
      }
      this.loadingExportMyData = false
    },
    async support () {
      this.loadingMessage = true
      try {
        await this.$store.dispatch('auth/sendQuestion', { msg: this.textMessage })
        this.textMessage = ''
        this.dialogMessage = false
        alert('Processamos sua solicitação e você será respondido o mais rápido possível. Obrigado.')
      } catch (e) {
        alert('Oops! Infelizmente ocorreu um erro ao executar a operação. Na dúvida, contate o suporte.')
      }
      this.loadingMessage = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>